/*
 * あなたにぴったりのベリー診断（sections/berry-diagnosis.liquid）
 * - 画面: 開始 → Q1〜Q5 → 結果。戻っても回答を保持する
 * - 採点: Q1 は一致で3点、Q2〜Q5 は一致で2点。Q3 の「どちらでもよい」(c) は全商品0点
 *         同点は ①Q1の一致 ②優先順位(小さいほど上) ③設定の並び順 で決定し、上位3商品を表示
 * - 計測: Shopify.analytics.publish でカスタムイベントを送る（カスタムピクセルが GTM の dataLayer へ中継）
 *         同じ操作での重複送信を防ぎ、個人情報は送らない
 * - 結果から商品ページへ進んだ場合、sessionStorage に記録し、商品ページのカート追加時に
 *   カート行のプロパティ（_diagnosis）として残す（theme.js 側で付与）
 */
(function () {
  'use strict';

  var DIAG_STORAGE_KEY = 'entowa_diagnosis_click';
  var QUESTION_IDS = ['q1', 'q2', 'q3', 'q4', 'q5'];

  function makeId() {
    return 'dx-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
  }
  function formatYen(cents) {
    return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
  }
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // 計測: Shopify のカスタムイベントとして送信（未対応環境では何もしない）
  function track(name, params) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) { /* 計測失敗は画面に影響させない */ }
  }

  function initDiagnosis(root) {
    if (root.dataset.dxReady) return;
    root.dataset.dxReady = 'true';

    var configEl = root.querySelector('[data-dx-config]');
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

    var screens = {};
    root.querySelectorAll('[data-dx-screen]').forEach(function (el) { screens[el.dataset.dxScreen] = el; });
    var live = root.querySelector('[data-dx-live]');

    var state = {
      diagnosisId: null,
      answers: {},        // { q1: 'a', ... }
      sent: {},           // 重複送信防止
      result: null
    };

    function sendOnce(key, name, params) {
      if (state.sent[key]) return;
      state.sent[key] = true;
      track(name, params);
    }

    function show(name) {
      Object.keys(screens).forEach(function (key) {
        var el = screens[key];
        var active = key === name;
        el.hidden = !active;
        el.classList.toggle('is-active', active);
      });
      var target = screens[name];
      if (!target) return;
      // 画面上部へ移動し、見出しにフォーカスを移す（読み上げ・キーボード操作のため）
      var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
      if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      var focusEl = target.querySelector('[data-dx-focus]');
      if (focusEl) focusEl.focus({ preventScroll: true });
    }

    function syncSelected(q) {
      var el = screens[q];
      if (!el) return;
      el.querySelectorAll('[data-dx-answer]').forEach(function (btn) {
        var selected = state.answers[q] === btn.dataset.dxAnswer;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
    }

    function start(isRestart) {
      state.diagnosisId = makeId();
      state.answers = {};
      state.sent = {};
      state.result = null;
      QUESTION_IDS.forEach(syncSelected);
      if (isRestart) track('diagnosis_restart', { diagnosis_id: state.diagnosisId });
      sendOnce('start', 'diagnosis_start', { diagnosis_id: state.diagnosisId });
      show('q1');
    }

    // ---------- 採点 ----------
    function score() {
      var candidates = (config.products || []).filter(function (p) {
        return p && p.url && (config.includeSoldOut || p.available);
      });
      var scored = candidates.map(function (p, index) {
        var total = 0;
        var q1Score = 0;
        var matched = [];
        QUESTION_IDS.forEach(function (q) {
          var answer = state.answers[q];
          var question = config.questions[q];
          if (!answer || !question) return;
          if (question.neutral && answer === question.neutral) return; // 中立回答は加点しない
          if ((p.match[q] || []).indexOf(answer) > -1) {
            total += question.weight;
            if (q === 'q1') q1Score = question.weight;
            matched.push(question.options[answer]);
          }
        });
        return { product: p, total: total, q1: q1Score, priority: p.priority || 99, order: index, matched: matched };
      });
      scored.sort(function (a, b) {
        return (b.total - a.total) || (b.q1 - a.q1) || (a.priority - b.priority) || (a.order - b.order);
      });
      return scored.slice(0, 3);
    }

    // ---------- 結果の描画 ----------
    function tasteHtml(taste) {
      var rows = [['sweet', '甘さ'], ['sour', '酸味'], ['astringent', '渋み']];
      // 味覚データが1項目でも未登録(0)なら表示しない（仮の数値を出さない）
      var registered = rows.every(function (r) { return taste && taste[r[0]] > 0; });
      if (!registered) return '';
      return '<dl class="ep-dx__taste">' + rows.map(function (r) {
        var v = taste[r[0]];
        var dots = '';
        for (var i = 1; i <= 5; i++) dots += '<span class="' + (i <= v ? 'is-on' : '') + '"></span>';
        return '<div><dt>' + r[1] + '</dt><dd aria-label="' + r[1] + ' 5段階中' + v + '">' + dots + '</dd></div>';
      }).join('') + '</dl>';
    }

    function reasonText(item) {
      if (!item.matched.length) return '';
      return (config.reasonPrefix || 'あなたが選んだ') + '「' + item.matched.slice(0, 3).join('」「') + '」にぴったりです。';
    }

    function productLink(item, rank, className, label) {
      var p = item.product;
      return '<a href="' + escapeHtml(p.url) + '" class="' + className + '" data-dx-product data-rank="' + rank + '" data-product-id="' + escapeHtml(p.id) + '" data-product-handle="' + escapeHtml(p.handle) + '" data-product-name="' + escapeHtml(p.title) + '">' + label + '</a>';
    }

    function renderResult(items) {
      var typeKey = state.answers.q1 || 'b';
      var type = (config.types && config.types[typeKey]) || {};
      root.querySelector('[data-dx-type]').textContent = type.name || '診断結果';
      var typeDesc = root.querySelector('[data-dx-type-desc]');
      typeDesc.textContent = type.desc || '';
      typeDesc.hidden = !type.desc;

      var topEl = root.querySelector('[data-dx-top]');
      var othersEl = root.querySelector('[data-dx-others]');
      var othersWrap = root.querySelector('[data-dx-others-wrap]');
      var emptyEl = root.querySelector('[data-dx-empty]');
      topEl.innerHTML = '';
      othersEl.innerHTML = '';

      if (!items.length) {
        emptyEl.hidden = false;
        othersWrap.hidden = true;
        return;
      }
      emptyEl.hidden = true;

      var top = items[0];
      var p = top.product;
      var reason = reasonText(top);
      topEl.innerHTML =
        '<article class="ep-dx__card ep-dx__card--top">' +
          '<div class="ep-dx__card-media">' +
            '<span class="ep-dx__rank">おすすめ No.1</span>' +
            (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.imageAlt) + '" loading="eager" decoding="async" width="900" height="900">' : '') +
          '</div>' +
          '<div class="ep-dx__card-body">' +
            '<h3 class="ep-dx__card-title">' + escapeHtml(p.title) + '</h3>' +
            '<p class="ep-dx__card-price">' + formatYen(p.price) + '<small>（税込）</small></p>' +
            (p.flavor ? '<p class="ep-dx__card-row"><span>味の特徴</span>' + escapeHtml(p.flavor) + '</p>' : '') +
            (reason ? '<p class="ep-dx__card-row"><span>おすすめ理由</span>' + escapeHtml(reason) + '</p>' : '') +
            (p.howto ? '<p class="ep-dx__card-row"><span>おすすめの食べ方</span>' + escapeHtml(p.howto) + '</p>' : '') +
            (p.note ? '<p class="ep-dx__card-note">' + escapeHtml(p.note) + '</p>' : '') +
            tasteHtml(p.taste) +
            productLink(top, 1, 'btn btn-primary ep-dx__cta', escapeHtml(config.ctaLabel || 'この商品を詳しく見る')) +
          '</div>' +
        '</article>';

      var others = items.slice(1);
      othersWrap.hidden = others.length === 0;
      others.forEach(function (item, i) {
        var op = item.product;
        var rank = i + 2;
        var card = document.createElement('article');
        card.className = 'ep-dx__card ep-dx__card--other';
        card.innerHTML =
          '<div class="ep-dx__card-media">' +
            '<span class="ep-dx__rank ep-dx__rank--sub">No.' + rank + '</span>' +
            (op.image ? '<img src="' + escapeHtml(op.image) + '" alt="' + escapeHtml(op.imageAlt) + '" loading="eager" decoding="async" width="600" height="600">' : '') +
          '</div>' +
          '<div class="ep-dx__card-body">' +
            '<h4 class="ep-dx__card-title">' + escapeHtml(op.title) + '</h4>' +
            '<p class="ep-dx__card-price">' + formatYen(op.price) + '<small>（税込）</small></p>' +
            (op.flavor ? '<p class="ep-dx__card-flavor">' + escapeHtml(op.flavor) + '</p>' : '') +
            tasteHtml(op.taste) +
            productLink(item, rank, 'ep-dx__card-link', escapeHtml(config.ctaLabel || 'この商品を詳しく見る') + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>') +
          '</div>';
        othersEl.appendChild(card);
      });
    }

    function finish() {
      var items = score();
      state.result = items;
      renderResult(items);
      show('result');
      if (live) live.textContent = '診断結果を表示しました。';
      var top = items[0];
      sendOnce('complete', 'diagnosis_complete', {
        diagnosis_id: state.diagnosisId,
        result_type: state.answers.q1 || '',
        recommended_product_id: top ? String(top.product.id) : '',
        recommended_product_name: top ? top.product.title : ''
      });
    }

    // ---------- 操作 ----------
    root.querySelector('[data-dx-start]').addEventListener('click', function () { start(false); });

    root.querySelectorAll('[data-dx-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.dataset.dxQuestion;
        var a = btn.dataset.dxAnswer;
        if (!state.diagnosisId) start(false);
        state.answers[q] = a;
        syncSelected(q);
        sendOnce('answer:' + q + ':' + a, 'diagnosis_answer', { diagnosis_id: state.diagnosisId, question_id: q, answer_id: a });
        var index = QUESTION_IDS.indexOf(q);
        // 選択が見えるよう少し待ってから次へ（動きを減らす設定では即時）
        setTimeout(function () {
          if (index < QUESTION_IDS.length - 1) show(QUESTION_IDS[index + 1]);
          else finish();
        }, prefersReducedMotion() ? 0 : 220);
      });
    });

    root.querySelectorAll('[data-dx-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = btn.closest('[data-dx-screen]').dataset.dxScreen;
        var index = QUESTION_IDS.indexOf(current);
        if (index > 0) show(QUESTION_IDS[index - 1]);
      });
    });
    root.querySelectorAll('[data-dx-back-start]').forEach(function (btn) {
      btn.addEventListener('click', function () { show('start'); });
    });
    root.querySelector('[data-dx-restart]').addEventListener('click', function () { start(true); });

    // おすすめ商品のクリック（イベント送信と、商品ページでのカート記録用に保存）
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-dx-product]');
      if (!link) return;
      var rank = parseInt(link.dataset.rank, 10);
      sendOnce('click:' + link.dataset.productId + ':' + rank, 'diagnosis_product_click', {
        diagnosis_id: state.diagnosisId,
        result_type: state.answers.q1 || '',
        recommended_product_id: link.dataset.productId,
        recommended_product_name: link.dataset.productName,
        recommendation_rank: rank
      });
      try {
        sessionStorage.setItem(DIAG_STORAGE_KEY, JSON.stringify({
          handle: link.dataset.productHandle,
          rank: rank,
          type: state.answers.q1 || '',
          diagnosisId: state.diagnosisId,
          at: Date.now()
        }));
      } catch (err) { /* 保存できない環境では記録しない */ }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-diagnosis]').forEach(initDiagnosis);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
